import { FundQueryQueryState } from '../enums';

export const FundQueryQueryStates = [
  { name: 'Success', value: FundQueryQueryState.Success },
  { name: 'Failed', value: FundQueryQueryState.Failed },
];
